import React, { useEffect, useState } from "react";
import { CommonTableUI } from "../../TableTemplate/common";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { IOptionDomainTableReport } from "../../../Interfaces/optionDomain";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import { setOptionDomainFlag } from "../../../Features/OptionDomain/optionDomainSlice";

const TableUI: React.FC<ITableUI<IOptionDomainTableReport>> = ({
  reports,
  onAction,
  AdditionalBody,
  sortingType,
  setSortingType,
}: ITableUI<IOptionDomainTableReport>) => {
  const flag = useAppSelector((store) => store.optionDomain.tableRefetchFlag);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!!flag && onAction) {
      dispatch(setOptionDomainFlag(false));
      onAction();
    }
  }, [flag]);

  return (
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      AdditionalBody={AdditionalBody}
      sortingType={sortingType}
      setSortingType={setSortingType}
    />
  );
};

export default TableUI;
